import React from 'react';

export const cnaColors = [
  {
    bg: '#FFF4CC',
    inner: '#F5E9B8',
    border: '#E6D48A',
  },
  {
    bg: '#DFF7EA',
    inner: '#CFEEDD',
    border: '#A9D8C1',
  },
  {
    bg: '#FFD6E7',
    inner: '#F5C2D8',
    border: '#E39ABF',
  },
  {
    bg: '#DCEFFD',
    inner: '#CBE3F5',
    border: '#A9C8E6',
  },
  {
    bg: '#EEEEEE',
    inner: '#E0E0E0',
    border: '#C2C2C2',
  },
  {
    bg: '#FFD8CC',
    inner: '#F5C3B5',
    border: '#E09A8A',
  },
  {
    bg: '#E4DEFF',
    inner: '#D3CBF5',
    border: '#B0A6E0',
  },
  {
    // Brown
    bg: '#E8D5C4',
    inner: '#D8C0AA',
    border: '#B48A68',
  },
  {
    // Deep Green
    bg: '#C3DDC8',
    inner: '#9FC6A8',
    border: '#1F5A35',
  },
  {
    bg: '#FFE6CC',
    inner: '#F5D3B5',
    border: '#E0B38A',
  },
];

export const tableColumns = [
  {
    header: 'CNA',
    accessorKey: 'cna',
    cellClassName: 'cna',
  },
  {
    header: 'Room',
    accessorKey: 'room',
    cellClassName: 'room',
  },
  {
    header: 'Resident',
    accessorKey: 'resident',
    cellClassName: 'resident',
  },
  {
    header: 'Tasks',
    accessorKey: 'tasks',
    cellClassName: 'tasks',
  },
];

export const shiftOptions = [
  {
    label: '7-3',
    value: '7_3',
  },
  {
    label: '3-11',
    value: '3_11',
  },
  {
    label: '11-7',
    value: '11_7',
  },
];

export const periodOptions = [
  {
    label: 'Days in a week',
    value: 'week_days',
  },
  {
    label: 'Custom dates',
    value: 'custom_dates',
  },
  {
    label: 'Custom interval',
    value: 'custom_interval',
  },
];

export const weekDaysOptions = [
  {
    label: 'Sunday',
    value: 0,
  },
  {
    label: 'Monday',
    value: 1,
  },
  {
    label: 'Tuesday',
    value: 2,
  },
  {
    label: 'Wednesday',
    value: 3,
  },
  {
    label: 'Thursday',
    value: 4,
  },
  {
    label: 'Friday',
    value: 5,
  },
  {
    label: 'Saturday',
    value: 6,
  },
];

export const quantityOptions = [
  {
    label: 'every',
    value: 1,
  },
  {
    label: 'every 2nd',
    value: 2,
  },
  {
    label: 'every 3rd',
    value: 3,
  },
  {
    label: 'every 4th',
    value: 4,
  },
  {
    label: 'every 5th',
    value: 5,
  },
];
